// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nKdm","importantInfo":"styles_importantInfo__CyCYl"};